<div class="dialog-body">
  <h2 class="dialog-title text-danger">{{ header() }}</h2>

  <div class="alert alert-warning">
    <h3>Warning: Read carefully and proceed with caution</h3>
    <ul class="mb-3">
      <li>Ensure Scores and Stats are valid before proceeding</li>
      <li>This is a bulk operation and cannot be undone</li>
      <li>All Scorecards in this Round will be Marked Official</li>
    </ul>
  </div>

  <div class="actions">
    <button type="button" class="btn btn-default" (click)="onCancel()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="onConfirm()">
      <i class="fa fa-check-square-o"></i> Mark All Official
    </button>
  </div>
</div>
